import {takeLatestF} from '@fl/cmsch-fe-library';
import {SagaIterator} from 'redux-saga';
import {put} from 'typed-redux-saga';

import {Api} from 'api/gen/Api';
import {tablesAction} from 'utils/tables';

import {GetCabCalvesAction, animalBrowserAction} from '../action';

const tableId = 'comprehensiveCalves';

function* execute(action: GetCabCalvesAction): SagaIterator {
    const {tableDataRequest} = action.payload;
    yield* put(tablesAction.getTableData({
        tableDataRequest,
        apiRequest: Api.findCabCalves,
        successAction: animalBrowserAction.getCabCalvesSucces,
        tableId,
    }));
}

/**
 * Loads comprehensive calf rows for the current browser view.
 *
 * @returns The saga watcher for `GET_CAB_CALVES`.
 */
export function* getCabCalvesSaga(): SagaIterator {
    yield takeLatestF('animalBrowser/GET_CAB_CALVES', execute);
}
